import { useComputedCompany } from "Components/Company/hooks/useComputedCompany";
import { useScheduleResources } from "Components/ScheduleResource/hooks/useScheduleResources";
import { useTranslation } from "Providers/TranslationProvider";
import { ScheduleGroupItem } from "domain-entities";
import React, { FC, Fragment } from "react";

interface Props {
	scheduleGroupItem: ScheduleGroupItem;
}

export const ScheduleGroupItemName: FC<Props> = (props) => {
	const { scheduleGroupItem } = props;
	const { t } = useTranslation();
	const scheduleResourceName = useScheduleResources(
		(state) =>
			state.items.find((item) => item.id === scheduleGroupItem.resourceId)?.name
	);
	const validMembers = useComputedCompany((state) => state.validMembers);
	const validMember = validMembers.find(
		(validMember) => validMember.id === scheduleGroupItem.userId
	);

	if (validMember) {
		return (
			<Fragment>
				{validMember.name} {validMember.lastname}
			</Fragment>
		);
	}

	if (scheduleResourceName) {
		return <Fragment>{scheduleResourceName}</Fragment>;
	}

	return <Fragment>{t("Common_Unknown")}</Fragment>;
};
